import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import setupI18next from './helpers/setupI18next.ts';
import addScript from './helpers/addScript.ts';
import setupMSW from './helpers/setupMSW.ts';
import AppConfig from './AppConfig.ts';
import { reloadForChunkError } from './helpers/chunkLoadRecovery.ts';

import './index.css';

// Stale-chunk recovery (see helpers/chunkLoadRecovery). Lazy route failures reach the
// router's errorElement; this catches Vite's CSS/dependency preloads, which never touch React.
// Not preventDefault()ed: the rejection still reaches the errorElement, which shows a
// spinner while the reload is in flight, or the error page once the budget is spent.
window.addEventListener('vite:preloadError', () => {
  reloadForChunkError();
});

setupI18next();
addScript(AppConfig.pendoMonitorScript);

// Only load Global Navigator script in deployed environments (not local)
if (!AppConfig.isLocal) {
  addScript(AppConfig.microFrontends['hb-global-navigator'].url);
}


if (process.env.NODE_ENV === 'development') {
  await setupMSW();
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
